import React from 'react'
import PropTypes from 'prop-types'
import { Card as LCard } from '@walmart-web/livingdesign-components'
import './index.css'

const Card = ({ children, ...rest }) => (
  <LCard className="card" {...rest}>
    {children}
  </LCard>
)

Card.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Card
